import React from 'react';
import { View } from 'react-native';
import { Trans } from '@lingui/react/macro';
import { Body, BriefLink, Heading, s } from './BriefPrimitives';

export default function ResearchBriefCallout() {
    return <View style={[s.section, s.green]}><View style={s.rail}>
        <Heading><Trans>A research brief you can talk to.</Trans></Heading>
        <Body><Trans>Connect Paperzilla to your AI assistant. Every morning, get the few new papers worth your time, why they matter, and answers to your follow-up questions.</Trans></Body>
        <BriefLink href="/research-briefs"><Trans>See how morning research briefs work →</Trans></BriefLink>
    </View></View>;
}
